<template>
  <div>
    <van-dropdown-menu>
      <van-dropdown-item v-model="value1" :options="option1" />
      <div class="screen">
        <van-icon name="search" />
        <van-icon name="filter-o" />
      </div>
    </van-dropdown-menu>
    <div class="main">
      <div class="list">
        <div class="item">
            <div class="top">
              <div class="left">
                <div class="headImg">
                  <img src="../assets/img/mrtx.png" alt="">
                  <!-- <van-image width="43" height="43" src="../assets/img/mrtx.png" /> -->
                </div>
                <div>
                  <p class="color-999 mb-10">郑元方</p>
                  <h3 class="color-666 fw-800">郑州代理商</h3>
                </div>
              </div>
              <div class="cooperation">
                <van-icon name="fire" />合作中
              </div>
            </div>
            <div class="foot">
              <div>
                <div>
                  联系方式：18513845458
                </div>
                <div>
                  到期时间：2019.12.31
                </div>
              </div>

              <div>
                <div>
                  审核状态：<span class="adopt"></span>通过
                </div>
                <div>
                  合作方式：课程代理
                </div>
              </div>
            </div>
        </div>
        <div class="item">
            <div class="top">
              <div class="left">
                <div class="headImg">
                  <img src="../assets/img/mrtx.png" alt="">
                  <!-- <van-image width="43" height="43" src="../assets/img/mrtx.png" /> -->
                </div>
                <div>
                  <p class="color-999 mb-10">郑元方</p>
                  <h3 class="color-666 fw-800">郑州代理商</h3>
                </div>
              </div>
              <div class="aboutExpire">
                <van-icon name="fire" />即将到期
              </div>
            </div>
            <div class="foot">
              <div>
                <div>
                  联系方式：18513845458
                </div>
                <div>
                  到期时间：2019.12.31
                </div>
              </div>

              <div>
                <div>
                  审核状态：<span class="noAdopt"></span>未通过
                </div>
                <div>
                  合作方式：课程代理
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      value1: 0,
      value2: 'a',
      option1: [
        { text: '全部商品', value: 0 },
        { text: '新款商品', value: 1 },
        { text: '活动商品', value: 2 }
      ]
    }
  },
  components: {
  }
}
</script>


<style scoped lang='less'>
/deep/ .van-dropdown-menu{
  justify-content: space-between;
  .van-dropdown-menu__item{justify-content: flex-start;
    .van-ellipsis{color: #333333;font-size: 16px;font-weight: 800;}
      .van-dropdown-menu__title--active{
        color: #E73928;
      }
   
  }
  .van-dropdown-item{
    .van-dropdown-item__option--active{
      color: #E73928;
      .van-cell__title{
        span{
         font-weight: 800;
        }
      }
      .van-icon{
       color: #E73928;
      }
    }
  }
}

.screen{
  width: 70px;
  display: flex;
  justify-content:space-around;
  align-items: center;
  font-size: 20px;
  color: #999999;
}
.main{
  padding:12px 15px;
  .list{
    .item{
      background: #fff;
      width: 345px;
      height: 150px;
      padding: 12px 15px;
      border-radius: 5px;
      margin-bottom: 10px;
      .top{
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #f5f5f5;
        padding-bottom: 16px;
        .left{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .headImg{
            width: 43px;
            height: 43px;
            margin-right: 10px;
          }
        }
        
      }
      .foot{
        padding-top: 16px;
        >div{
          display: flex;
          justify-content: space-between;
          color: #666;
          >div{
            margin-bottom: 12px;
          }
        }
      }
    }
  }
}
</style>


